module.exports = __webpack_public_path__ + "static/img/full-project.4afabcbc.svg";